import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline } from '@mui/material';

// Landing page
import LandingPage from './pages/LandingPage';

// Auth pages
import SellerRegister from './pages/SellerRegister';
import SellerLogin from './pages/SellerLogin';
import AdminLogin from './pages/AdminLogin';
import AdminRegister from './pages/AdminRegister';
import ForgotPassword from './pages/ForgotPassword';

// DLP auth pages
import DlpRegister from './pages/DlpRegister';
import DlpLogin from './pages/DlpLogin';

// Public order form
import OrderForm from './pages/OrderForm';

// Admin pages
import AdminDashboard from './pages/admin/Dashboard';
import AdminOrders from './pages/admin/Orders';
import SellerApprovals from './pages/admin/SellerApprovals';
import DlpApprovals from './pages/admin/DlpApprovals';
import FinanceDashboard from './pages/admin/FinanceDashboard';
import AdminSellers from './pages/admin/Sellers';
import AuditLogs from './pages/admin/AuditLogs';

// Seller pages
import SellerDashboard from './pages/seller/Dashboard';
import SellerOrders from './pages/seller/Orders';
import SellerReports from './pages/seller/Reports';
import SellerShareLink from './pages/seller/ShareLink';

// DLP pages
import DlpDashboard from './pages/dlp/Dashboard';
import DlpOrders from './pages/dlp/Orders';
import ScanDispatch from './pages/dlp/ScanDispatch';
import InboundScan from './pages/dlp/InboundScan';
import SortScan from './pages/dlp/SortScan';

// Protection
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <>
      <CssBaseline />

      <Routes>
        {/* Root */}
        <Route path="/" element={<LandingPage />} />

        {/* Public */}
        <Route path="/order-form/:sellerId" element={<OrderForm />} />

        {/* Seller Auth */}
        <Route path="/seller/register" element={<SellerRegister />} />
        <Route path="/seller/login" element={<SellerLogin />} />
        <Route
          path="/seller/forgot-password"
          element={<ForgotPassword role="seller" />}
        />

        {/* Admin Auth */}
        <Route path="/admin/register" element={<AdminRegister />} />
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* DLP Auth */}
        <Route path="/dlp/register" element={<DlpRegister />} />
        <Route path="/dlp/login" element={<DlpLogin />} />
        <Route
          path="/dlp/forgot-password"
          element={<ForgotPassword role="dlp" />}
        />

        {/* Admin Protected */}
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute role="admin">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/orders"
          element={
            <ProtectedRoute role="admin">
              <AdminOrders />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/approvals"
          element={
            <ProtectedRoute role="admin">
              <SellerApprovals />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/audit-logs"
          element={
            <ProtectedRoute role="admin">
              <AuditLogs />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/dlps"
          element={
            <ProtectedRoute role="admin">
              <DlpApprovals />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/dlp-approvals"
          element={
            <ProtectedRoute role="admin">
              <DlpApprovals />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/finance"
          element={
            <ProtectedRoute role="admin">
              <FinanceDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/all-sellers"
          element={
            <ProtectedRoute role="admin">
              <AdminSellers />
            </ProtectedRoute>
          }
        />

        {/* Optional Admin Redirects */}
        <Route
          path="/admin/sellers"
          element={<Navigate to="/admin/approvals" replace />}
        />

        <Route
          path="/admin/reports"
          element={<Navigate to="/admin/orders" replace />}
        />

        {/* Seller Protected */}
        <Route
          path="/seller/dashboard"
          element={
            <ProtectedRoute role="seller">
              <SellerDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/seller/orders"
          element={
            <ProtectedRoute role="seller">
              <SellerOrders />
            </ProtectedRoute>
          }
        />

        <Route
          path="/seller/share-link"
          element={
            <ProtectedRoute role="seller">
              <SellerShareLink />
            </ProtectedRoute>
          }
        />

        <Route
          path="/seller/reports"
          element={
            <ProtectedRoute role="seller">
              <SellerReports />
            </ProtectedRoute>
          }
        />

        {/* DLP Protected */}
        <Route
          path="/dlp/dashboard"
          element={
            <ProtectedRoute role="dlp">
              <DlpDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dlp/orders"
          element={
            <ProtectedRoute role="dlp">
              <DlpOrders />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dlp/scan-dispatch"
          element={
            <ProtectedRoute role="dlp">
              <ScanDispatch />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dlp/scan-inbound"
          element={
            <ProtectedRoute role="dlp">
              <InboundScan />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dlp/scan-sort"
          element={
            <ProtectedRoute role="dlp">
              <SortScan />
            </ProtectedRoute>
          }
        />

        {/* Fallback must be last */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default App;
